import { Component, OnInit, OnDestroy, EventEmitter, Output, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import {
  SalesCommissionCycleService, CompanyService,
  SalesCommissionCycleContainerModel,
  CompanyContainerModel
} from 'blg-akaun-ts-lib';
import { ReplaySubject, forkJoin, from, iif, of } from 'rxjs';
import { catchError, concatMap, debounceTime, distinctUntilChanged, map, mergeMap, tap, toArray } from 'rxjs/operators';
import { SubSink } from 'subsink2';
import { AppConfig } from '../../visa';
import { SharedUtilitiesHelperFunctions } from '../helper-functions';

@Component({
  selector: 'app-commission-cycle-dropdown',
  templateUrl: './commission-cycle-dropdown.component.html',
  styleUrls: ['./commission-cycle-dropdown.component.css']
})
export class CommissionCycleDropDownComponent implements OnInit, OnDestroy {

  @Input() commissionCycle: FormControl;
  @Output() commissionCycleChange = new EventEmitter<FormControl>();

  private subs = new SubSink();

  private apiVisa = AppConfig.apiVisa;
  filterControl = new FormControl();
  filteredOptions$: ReplaySubject<SalesCommissionCycleContainerModel[]> = new ReplaySubject<SalesCommissionCycleContainerModel[]>(1);
  entityList: SalesCommissionCycleContainerModel[];
  companyMap: { guid: string, name: string }[] = [];
  
  constructor( private salesCommissionCycleService: SalesCommissionCycleService,
                private companyService: CompanyService
    ) {}

  ngOnInit() {
    this.subs.sink = this.salesCommissionCycleService.get(this.apiVisa).pipe(
      mergeMap(a => from(a.data).pipe(
        concatMap(a_a => forkJoin([
          iif(() => !!this.companyMap.find(s => s.guid === a_a.bl_fi_sale_commission_cycle.comp_guid.toString()),
            of(this.companyMap.find(s => s.guid === a_a.bl_fi_sale_commission_cycle.comp_guid.toString())).pipe(
              map(a_a_a => {
                const container = new CompanyContainerModel();
                container.bl_fi_mst_comp.guid = a_a_a.guid;
                container.bl_fi_mst_comp.name = a_a_a.name;
                return container;
              })
            ),
            this.companyService.getByGuid(a_a.bl_fi_sale_commission_cycle.comp_guid.toString(), this.apiVisa).pipe(
              tap(a_a_b => this.companyMap.push(
                {
                  guid: a_a_b.data.bl_fi_mst_comp.guid.toString(),
                  name: (a_a_b.data.bl_fi_mst_comp.name ? a_a_b.data.bl_fi_mst_comp.name.toString() : a_a_b.data.bl_fi_mst_comp.status.toString()),
                })),
              map(a_a_c => a_a_c.data),
              catchError((err) => of(err))
            )
          )]
        ).pipe(
          map(([b_a]) => {
            Object.assign(a_a.bl_fi_sale_commission_cycle,
              {
                company: b_a.error ? b_a.error.code : (b_a.bl_fi_mst_comp.name ? b_a.bl_fi_mst_comp.name : b_a.bl_fi_mst_comp.status),
                dateStart: SharedUtilitiesHelperFunctions.dateFormatter(a_a.bl_fi_sale_commission_cycle.date_start),
                dateEnd: SharedUtilitiesHelperFunctions.dateFormatter(a_a.bl_fi_sale_commission_cycle.date_end),
              });
            return a_a;
          })
        )
        ),
        toArray(),
        map(b => {
          a.data = b;
          return a;
        })
      )
      )
    ).subscribe(
      {next: resolve => {
        const dataRow = resolve.data.sort((a, b) => {
          if (a.bl_fi_sale_commission_cycle['company'] === b.bl_fi_sale_commission_cycle['company']) {
            return new Date(b.bl_fi_sale_commission_cycle['dateStart']).getTime() - new Date(a.bl_fi_sale_commission_cycle['dateEnd']).getTime();
          }
          return a.bl_fi_sale_commission_cycle['company'].localeCompare(b.bl_fi_sale_commission_cycle['company']);
        });
        this.entityList = dataRow;
        this.filteredOptions$.next(this.entityList);
      }});
   
    this.subs.sink = this.filterControl.valueChanges.pipe(
      debounceTime(300),
      distinctUntilChanged()
    ).subscribe({next: resolve => this.filterCurrency(resolve)});
  }

  filterCurrency(search: string) {
    if (!search) {
      this.filteredOptions$.next(this.entityList);
    } else {
      search = search.toLocaleLowerCase();
      const filter = this.entityList.filter(c => c.bl_fi_sale_commission_cycle['company'].toLocaleLowerCase().includes(search));
      this.filteredOptions$.next(filter);
    }

  }

  displayData(data) {
    return data.bl_fi_sale_commission_cycle.company + 
    " (" + SharedUtilitiesHelperFunctions.dateFormatter(data.bl_fi_sale_commission_cycle.date_start) +
    " - " + SharedUtilitiesHelperFunctions.dateFormatter(data.bl_fi_sale_commission_cycle.date_end) + ")";
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}

